module.exports = __webpack_public_path__ + "img/PIVX-alt.d848390e.svg";